import { render, staticRenderFns } from "./dose.vue?vue&type=template&id=3b1e80a8&scoped=true"
import script from "./dose.vue?vue&type=script&lang=js"
export * from "./dose.vue?vue&type=script&lang=js"
import style0 from "./dose.vue?vue&type=style&index=0&id=3b1e80a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e80a8",
  null
  
)

export default component.exports